import { useState } from 'react'

import RequestDetails from './components/RequestDetails/RequestDetails'
import YardiSettings from './components/YardiSettings/YardiSettings'
import EntrataSettings from './components/EntrataSettings/EntrataSettings'
import RealPageSettings from './components/RealPageSettings/RealPageSettings'
import NativeSettings from './components/NativeSettings/NativeSettings'
import ResmanSettings from './components/ResmanSettings/ResmanSettings'
import RentManagerSettings from './components/RentManagerSettings/RentManagerSettings'

/**
 * @param {{
 *   toggleModal: () => void,
 *   voicemailChatMessageSid?: string,
 *   inspectionId?: number,
 *   description?: string,
 *   defaultResident?: object,
 *   defaultBuilding?: object,
 *   defaultPhotos?: string[],
 *   checklistRoomItemId?: number,
 *   lockResident?: import('@/models/features').LockedResident,
 *   lockBuilding?: import('@/reducers/types').Building | null,
 *   onSuccess?: () => void,
 * }} props
 */
const RequestMaintenanceForm = ({
  toggleModal,
  voicemailChatMessageSid = undefined,
  inspectionId = undefined,
  description = undefined,
  defaultResident = undefined,
  defaultBuilding = undefined,
  defaultPhotos = undefined,
  checklistRoomItemId = undefined,
  lockResident = undefined,
  lockBuilding = undefined,
  onSuccess = () => {},
}) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [integrationProvider, setIntegrationProvider] = useState('')
  const [building, setBuilding] = useState({})
  const [resident, setResident] = useState({})
  const [assignee, setAssignee] = useState({})
  const [phase, setPhase] = useState(null)
  const [requestType, setRequestType] = useState(null)

  const onBack = () => {
    setCurrentStep((prev) => prev - 1)
  }

  const onNext = () => {
    setCurrentStep((prev) => prev + 1)
  }

  const getViewBasedOnProvider = (provider) => {
    switch (provider) {
      case 'yardi':
        return (
          <YardiSettings
            description={description}
            onBack={onBack}
            onCancel={toggleModal}
            building={building}
            assignee={assignee}
            resident={resident}
            phase={phase}
            voicemailChatMessageSid={voicemailChatMessageSid}
            inspectionId={inspectionId}
            defaultPhotos={defaultPhotos}
            checklistRoomItemId={checklistRoomItemId}
            onSuccess={onSuccess}
          />
        )
      case 'entrata':
        return (
          <EntrataSettings
            description={description}
            onBack={onBack}
            onCancel={toggleModal}
            building={building}
            assignee={assignee}
            resident={resident}
            voicemailChatMessageSid={voicemailChatMessageSid}
            inspectionId={inspectionId}
            checklistRoomItemId={checklistRoomItemId}
            onSuccess={onSuccess}
          />
        )
      case 'realPage':
        return (
          <RealPageSettings
            description={description}
            onBack={onBack}
            onCancel={toggleModal}
            building={building}
            assignee={assignee}
            resident={resident}
            requestType={requestType}
            voicemailChatMessageSid={voicemailChatMessageSid}
            inspectionId={inspectionId}
            checklistRoomItemId={checklistRoomItemId}
            onSuccess={onSuccess}
          />
        )
      case 'resman':
        return (
          <ResmanSettings
            description={description}
            onBack={onBack}
            onCancel={toggleModal}
            building={building}
            assignee={assignee}
            resident={resident}
            voicemailChatMessageSid={voicemailChatMessageSid}
            inspectionId={inspectionId}
            checklistRoomItemId={checklistRoomItemId}
            onSuccess={onSuccess}
          />
        )
      case 'rentManager':
        return (
          <RentManagerSettings
            description={description}
            onBack={onBack}
            onCancel={toggleModal}
            building={building}
            assignee={assignee}
            resident={resident}
            voicemailChatMessageSid={voicemailChatMessageSid}
            inspectionId={inspectionId}
            checklistRoomItemId={checklistRoomItemId}
            onSuccess={onSuccess}
          />
        )
      default:
        return (
          <NativeSettings
            description={description}
            onBack={onBack}
            onCancel={toggleModal}
            building={building}
            assignee={assignee}
            resident={resident}
            voicemailChatMessageSid={voicemailChatMessageSid}
            inspectionId={inspectionId}
            defaultPhotos={defaultPhotos}
            checklistRoomItemId={checklistRoomItemId}
            onSuccess={onSuccess}
          />
        )
    }
  }

  const getView = (step) => {
    switch (step) {
      case 0:
        return (
          <RequestDetails
            setIntegrationProvider={setIntegrationProvider}
            integrationProvider={integrationProvider}
            setBuilding={setBuilding}
            setResident={setResident}
            setAssignee={setAssignee}
            setPhase={setPhase}
            setRequestType={setRequestType}
            onNext={onNext}
            onCancel={toggleModal}
            defaultBuilding={defaultBuilding}
            defaultResident={defaultResident}
            lockResident={lockResident}
            lockBuilding={lockBuilding}
          />
        )
      case 1:
        return getViewBasedOnProvider(integrationProvider)
      default:
        return null
    }
  }

  return getView(currentStep)
}

export default RequestMaintenanceForm
